import TimelineView from '@/modules/Oncall/components/Assignments/Timeline'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'

const OncallTimelineWidget: React.FC = () => {
    const { t } = useTranslation('dashboard')

    return (
        <div className="h-full flex flex-col">
            <div className="flex items-center justify-between flex-shrink-0">
                <Typogaphy className="font-semibold text-primary">
                    {t('technical.oncall_timeline')}
                </Typogaphy>
            </div>

            <div className="flex-1 min-h-0 overflow-auto">
                <TimelineView showActions={false} />
            </div>
        </div>
    )
}

export default OncallTimelineWidget
